import { useState, useCallback } from 'react'

let toastCallback = null

export const useToast = () => {
  const [toasts, setToasts] = useState([])

  const showToast = useCallback((message, type = 'success') => {
    const id = Date.now()
    const toast = { id, message, type }
    
    setToasts(prev => [...prev, toast])
    
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id))
    }, 3000)
  }, [])

  // Exposer la fonction globalement
  if (!toastCallback) {
    toastCallback = showToast
  }

  return { toasts, showToast }
}

// Export pour utilisation globale
export const toast = {
  success: (message) => toastCallback?.(message, 'success'),
  error: (message) => toastCallback?.(message, 'error'),
  info: (message) => toastCallback?.(message, 'info')
}

export default useToast
